import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { I18nProvider, SUPPORTED } from "@/i18n";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import Terms from "@/pages/Terms";
import ThankYou from "@/pages/ThankYou";
import { applyStoredConsentOnLoad } from "@/lib/consent";
import "@/App.css";

function LangGate() {
  const { lang } = useParams();
  if (!SUPPORTED.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return null;
}

function LangShell({ children }) {
  return (
    <>
      <LangGate />
      <Layout>{children}</Layout>
    </>
  );
}

function App() {
  React.useEffect(() => {
    // Re-apply any previously stored consent on load, then update lang html attr.
    applyStoredConsentOnLoad();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <I18nProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/ar" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />

          <Route path="/:lang" element={<LangShell><Home /></LangShell>} />
          <Route path="/:lang/privacy" element={<LangShell><PrivacyPolicy /></LangShell>} />
          <Route path="/:lang/cookies" element={<LangShell><CookiePolicy /></LangShell>} />
          <Route path="/:lang/terms" element={<LangShell><Terms /></LangShell>} />

          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Routes>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
